import { render, staticRenderFns } from "./BaseButtonField.vue?vue&type=template&id=4aa8f1e2&scoped=true&"
import script from "./BaseButtonField.vue?vue&type=script&setup=true&lang=ts&"
export * from "./BaseButtonField.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./BaseButtonField.vue?vue&type=style&index=0&id=4aa8f1e2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa8f1e2",
  null
  
)

export default component.exports